import HTTP from "@/_helpers/http";
import { LIVEACCOUNTS__API } from "@/_helpers/urls";
import { LIVEACCOUNTS__MUTATIONS } from "../mutation-types";
import { LIVEACCOUNTS__ACTIONS } from "../action-types";

// State
const state = {
  accounts: [],
  totalEquity: 0,
  totalBalance: 0,
  isLoading: false,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [LIVEACCOUNTS__MUTATIONS.LIVEACCOUNTS](state, data) {
    state.accounts = data?.data?.accounts;
    state.totalEquity = data?.data?.totalEquity;
    state.totalBalance = data?.data?.totalBalance;
    state.pagination = data?.data?.pagination;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
};

// Actions
const actions = {
  async [LIVEACCOUNTS__ACTIONS.LIVEACCOUNTS]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);

      const {
        trading_account_type_id,
        testData,
        duration,
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(trading_account_type_id && { trading_account_type_id }),
        ...(testData && { testData }),
        ...(duration && { duration }),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${LIVEACCOUNTS__API.LIVEACCOUNTS}${queryParams ? `?${queryParams}` : ''}`
      );

      commit(LIVEACCOUNTS__MUTATIONS.LIVEACCOUNTS, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
